import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  editor?: object;
  content?: string;
}

const propsSchema: PropsSchemaList = [
  {
    key: 'content',
    label: 'content',
    type: types.TINYMCE,
  },
];

const defaultProps: Props = {
  content: null
};

export default {
  title: 'Attention Bar',
  id: 'AttentionBar',
  propsSchema,
  defaultProps,
}
